// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"78":"2509b535","545":"c297b497","812":"5d037ed5"}[chunkId] + ".css";
};